import { autoinject } from 'aurelia-framework';
import { BaseApiService } from './base-api-service';
import { Models } from 'models/core';
import { AuthHttpClient } from './auth-http-client';

@autoinject
export class ForeignObjectService extends BaseApiService<Models.ForeignObject> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.ForeignObject);
  }

  public async updateForeignObjectList(data) {
    return await this.httpClient.exec(`${Models.ForeignObject.ApiUrl}/updateForeignObjects`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
